import TableCell from '@mui/material/TableCell'
import TableHeader from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableSortLabel from '@mui/material/TableSortLabel'

import { SortablePagingParams } from 'components/Table'
import { HeadCell } from 'components/Table/types'

interface Props<TFields> {
  headCells: HeadCell<TFields>[]
  pagingParams?: SortablePagingParams<TFields>
  setPagingParams?: (params: Partial<SortablePagingParams<TFields>>) => void
  gridTemplateColumns: string
}

const DataTableHeader = function <TFields>({
  headCells,
  gridTemplateColumns,
  pagingParams,
  setPagingParams,
}: Props<TFields>) {
  const handleSort = (newSortField: keyof TFields) => {
    const isAsc = pagingParams?.sortField === newSortField && pagingParams.sortDirection === 'asc'
    const toggledOrder = isAsc ? 'desc' : 'asc'

    setPagingParams &&
      setPagingParams({ sortDirection: toggledOrder, sortField: newSortField, pageIndex: 0 })
  }

  return (
    <TableHeader>
      <TableRow
        sx={{
          display: 'grid',
          gridTemplateColumns: gridTemplateColumns,
          boxShadow: '-1px 3px 5px 1px #A4A4A440',
          boxSizing: 'border-box',
          margin: '2px 2px 24px',
        }}
      >
        {headCells.map((headCell) => {
          const { isSortable = true, align = 'center' } = headCell

          return (
            <TableCell
              key={headCell.id}
              align={align}
              sx={{ justifyContent: align }}
              sortDirection={
                pagingParams && pagingParams.sortField === headCell.id
                  ? pagingParams.sortDirection
                  : false
              }
            >
              {isSortable && pagingParams ? (
                <TableSortLabel
                  sx={{ ml: align === 'center' ? 3 : 0, justifyContent: align }}
                  active={pagingParams?.sortField === headCell.id}
                  direction={
                    pagingParams.sortField === headCell.id ? pagingParams.sortDirection : 'asc'
                  }
                  title={`sorting by ${headCell.label}`}
                  onClick={() => {
                    handleSort(headCell.id)
                  }}
                >
                  {headCell.label}
                </TableSortLabel>
              ) : (
                headCell.label
              )}
            </TableCell>
          )
        })}
      </TableRow>
    </TableHeader>
  )
}

export default DataTableHeader
